import React, { Component } from 'react'
import { connect } from 'react-redux'
import StockBalanceExport from './StockBalanceExport'
import {getSheetByCurrentPage} from './jobs-reducer'
import {downloadStockBalance} from './utils'

class StockBalanceExportContainer extends Component {
  constructor (props) {
    super(props)
    this.state = {
      downloading: false
    }
  }

  handleDownload () {
    const {getSheetByCurrentPage, products} = this.props
    this.setState({downloading: true})
    // download based on the current job pagination
    const currentPageData = getSheetByCurrentPage()
    downloadStockBalance(currentPageData, products)
      .then(done => {
        this.setState({downloading: false})
      })
  }

  render () {
    const {requestOngoing, isJobsRequestOngoing} = this.props

    return <StockBalanceExport
      onDownloadFile={() => this.handleDownload()}
      requestOngoing={this.state.downloading || requestOngoing || isJobsRequestOngoing}
    />
  }
}

const mapStateToProps = ({ jobs: { requestOngoing, isJobsRequestOngoing, stockBalanceCSVRows }, products: {products} }) => ({
  requestOngoing,
  isJobsRequestOngoing,
  products
})

export default connect(mapStateToProps, {getSheetByCurrentPage})(StockBalanceExportContainer)



// WEBPACK FOOTER //
// ./src/jobs/StockBalanceExportContainer.js